<template>
  <transition name="fade">
    <div v-if="isPopupVisible" class="fullscreen-popup__overlay" @click.self="handleOverlayClick">
      <transition name="slide-up">
        <div class="fullscreen-popup__content-wrapper" role="dialog" :aria-hidden="!isPopupVisible" :style="wrapperStyles()">
          <div class="fullscreen-popup__header">
            <div class="flex justify-between align-center">
              <PopupTitle class="fullscreen-popup__title">{{ title }}</PopupTitle>
              <button v-if="closeable" class="popup-close-button" @click="close">
                <span class="popup-close-button-box"></span>
              </button>
            </div>
            <Divider type="horizontal" />
          </div>

          <div class="fullscreen-popup__scroll-content">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { POPUP_EVENTS } from '../../config';
import { popupView } from '../../lib';
import { Divider } from '@/shared/ui/divider';
import { PopupTitle } from '@/shared/ui/full-screen-popup';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    closeable: {
      type: Boolean,
      default: true,
    },
    minWidth: {
      type: Number,
      default: null,
    },
    maxWidth: {
      type: Number,
      default: null,
    },
  },
  created() {
    this.$eventBus.$on(POPUP_EVENTS.CLOSE, this.handleClosePopup);
  },
  beforeDestroy() {
    this.$eventBus.$off(POPUP_EVENTS.CLOSE, this.handleClosePopup);
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },
  mixins: [ popupView ],
  components: { PopupTitle, Divider },
  watch: {
    isPopupVisible(visible) {
      if (visible) {
        this.$nextTick(() => {
          if (this.$el && this.$el.nodeType === 1) {
            document.body.appendChild(this.$el);
          }
        });
      }
    },
  },
  methods: {
    wrapperStyles() {
      const styles = {};
      if (this.minWidth) styles['min-width'] = `${this.minWidth}px`;
      if (this.maxWidth) styles['max-width'] = `${this.maxWidth}px`;
      return styles;
    },
    open() { this.openPopup(); },
    close() { this.closePopup(this.getPopupId); },
    handleOverlayClick() {
      if (this.closeable) {
        this.close();
      }
    },
    handleClosePopup(data) {
      if (data?.id === this.getPopupId && !data?.isVisible) {
        this.closePopup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fullscreen-popup {
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  &__content-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #ffffff;
    border: 1px solid #E4E4E7;
    border-radius: 16px;
    max-height: 90vh;
    max-height: 90dvh;
    box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;
    z-index: 5;

    @media (max-width: 1050px) {
      margin-bottom: 70px;
    }

    @media (max-width: 550px) {
      width: 95%;
    }
  }

  &__title {
    margin-bottom: 0;
  }

  &__header {
    margin: 0 8px;
    padding: 16px 16px 0;
  }

  &__scroll-content {
    margin: 0 8px 8px;
    padding: 0 24px 8px 16px;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    flex-grow: 1;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-up-enter-active, .slide-up-leave-active {
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  }

  .slide-up-enter, .slide-up-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }
}

.popup-close-button {
  position: relative;
  cursor: pointer;
  padding-bottom: 10px;
  background: none;
  border: none;
  top: 6px;
  right: 6px;
  z-index: 10;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }

  &-box {
    position: relative;
    width: 12px;
    height: 12px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 12px;
      height: 1.5px;
      background-color: #000000;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
}
</style>
